import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory,useParams} from "react-router-dom";
import { Card,Button } from '@mui/material';
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import PageTitle from "../UI/PageTitle";
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import FileUploader from "../FileUploader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteIcon from "@mui/icons-material/Delete";
function EditComingOutlet() {
    let history = useHistory();
    let { id } = useParams();
    useEffect(() => {
        editoutlets();
      }, []);

    const [selectedFile, setSelectedFile] = useState(null);
    const [outlet, setOutlet] = useState({
        name: '',
        status: '',
     
       
    });

    const handleFileSelectSuccess = (file) => {
        setSelectedFile(file);
      };
    
      const handleFileSelectError = ({ error }) => {
        alert(error);
      };
      
    const [loading, setloading] = useState(false);
    const { name , status,image } = outlet;
    const onInputChange = e => {
        setOutlet({ ...outlet, [e.target.name]: e.target.value })
        //console.log(airmenu_id,"jeet");
    }

    const editoutlets = async () => {
        let a = localStorage.getItem("user");
        let b = JSON.parse(a);
        let user_id = b.id;
        let status = b.status;
        let name = b.name;
    
        await axios
          .post(endpoints.editLotdCSoon, {
            id: id,
            name: name,
            status: status,
          })
          .then((response) => {
            setOutlet({
              id: response.data.data.id,
              name: response.data.data.name,
              status: response.data.data.status,
              image: response.data.data.image,
              
            });
          });
      };

      const onSubmit = async (e) => {
        setloading(true);
        e.preventDefault();
        
        const formData = new FormData();
    
        formData.append("name", name);
        formData.append("status", status);
        formData.append("id", id);
    
        formData.append("image", selectedFile);
    
        try {
          const response = await axios.post(endpoints.updateLotdCSoon, formData);
          setloading(false);
          history.goBack();
          if (response.data && response.data.status === true) {
            toast.success("Coming Outlet Updated Successfully!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            // Handle other cases if needed
          }
        } catch (error) {
          console.error("Error during Updated Outlet:", error);
          setloading(false);
    
          toast.error("Error during Updated Outlet. Please try again.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      };
    
      const removeImageHandler = async (id, type) => {
        await axios
          .post(endpoints.deleteImageLotdCSoon, { id, type })
          .then((response) => {});
        window.location.reload();
      };
  return (
    <div>
    <PageTitle title="Edit Coming Soon Outlet" linkurl="" linkTitle="" />
   
   <Card className="px-3 py-3 mt-4">
           <form className="ui form" onSubmit={e => onSubmit(e)} encType="multipart/form-data">
           <div className="row mt-3">
                   <Input label="Name" type="text" name="name" place="Name" onChange={(e) => onInputChange(e)}
                       requiredInput="required" value={name} class="col-md-4"
                   />
                     <div className="col col-4 mt-2">
         <label>Status</label>
         <select
           name="status"
           required
           className="form-control"
           value={status}
           onChange={(e) => onInputChange(e)}
         >
           <option value="">Select Status</option>
           <option value="2">InActive</option>
           <option value="1">Active</option>
         </select>
       </div>
       <div className="col col-4">
              <label>Image</label>
              {image !== "https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/" ? (
                <div className="mt-3">
                  <img
                    src={image}
                    height="200px"
                    width="200px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "image")}
                  >
                    {/* Delete */}
                  </Button>
                </div>
              ) : (
                <div className="mt-3">
                  <FileUploader
                    onFileSelectSuccess={handleFileSelectSuccess}
                    onFileSelectError={handleFileSelectError}
                  />
                  {selectedFile && (
                    <div>
                      <p>Preview:</p>
                      <img
                        src={URL.createObjectURL(selectedFile)}
                        alt="Selected Logo"
                        height="200px"
                        width="200px"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
               </div>
              
             


               <div className="row">
                   <div className="col col-6">
                       <div className="mt-3">
                           <LoadingButton
                               type="submit"
                               loading={loading}
                               loadingPosition="start"
                               startIcon={<SaveIcon />}
                               variant="contained"
                               size="large"
                           >
                               Save
                           </LoadingButton>
                           <ToastContainer />

                       </div></div></div>


           </form>
       </Card>
</div>
  )
}

export default EditComingOutlet